import { render, staticRenderFns } from "./PlayerItemContent.vue?vue&type=template&id=071fa86d&"
import script from "./PlayerItemContent.vue?vue&type=script&lang=ts&"
export * from "./PlayerItemContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports